import { Failure } from "./failure";

export class DataObject<T = any> {
  constructor(public failure?: Failure | null, public data?: T | null) {}

  public isFailure(): boolean {
    return !!this.failure;
  }
}
